const m = require("air-vue-model")();
m.url = "ingredients";
m.name = "ingredient";

module.exports = m;